import React, { useState, useEffect } from "react";
import Login from "./containers/Login";
import { Container } from "@material-ui/core";
import "./App.scss";
import Routes from "./Routes";
import Header from "./containers/Header";
import { AppContext } from "./libs/contextLib";
import { Auth } from "aws-amplify";
//import { useHistory } from "react-router-dom";
import { onError } from "./libs/errorLib";

function App() {
  //console.log("App");
  //const history = useHistory();
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [thisUsername, setUsername] = useState(false);
  const [thisSub, setSub] = useState(false);

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    try {
      await Auth.currentSession();
      userHasAuthenticated(true);
      let user = await Auth.currentAuthenticatedUser();
      const { username } = user;
      const { sub } = user.attributes;
      setUsername(username);
      setSub(sub);
      } catch (e) {
      if (e !== "No current user") {
        onError(e);
      }
    }
    setIsAuthenticating(false);
  }


  onLoad();
  return (
    !isAuthenticating && (
      <div className="App container py-3">
          <AppContext.Provider
            value={{ isAuthenticated, userHasAuthenticated, thisUsername, setUsername, thisSub, setSub }}
          >
        <Header />
        <Container>
        {isAuthenticated ? false : <Login />}
            <Routes />
        </Container>
        </AppContext.Provider>
      </div>
    )
  );
}

export default App;
